/*******************************************************************************
WATCH INPUT BOX THAT USES CLEAR BUTTON
Watch for keystrokes inside the input box.
*******************************************************************************/

import clearInputBox from './clear';

export default function watchInputWithClearButton(e) {
    const $input = $(e.currentTarget);
    const $inputWrapper = $input.parents('.input-wrapper');
    const customClearClass = $inputWrapper.data('clear-class');

    // Build the clear button
    const $clearButton = $('<div />', { class: `input-clear ${customClearClass}` }).text('Clear');

    // Add the clear button if it doesn't exist
    $inputWrapper.find('.input-clear').doIfNotExists(() => { $inputWrapper.append($clearButton); });

    // If the input is empty (or the ESC key is pressed, then get rid of the clear button
    if (!$input.val() || e.which === 27) { clearInputBox($input); }
}
